import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [toggleNotification, setToggleNotification] = useState(false);

  const login = (token, userDetails) => {
    setIsLoggedIn(true);
    setToken(token);
    setUser(userDetails);
  };

  const toggleNotificationHandler = () => {
    setToggleNotification(!toggleNotification);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    setToken(null);
    setUser(null);
    setIsLoggedIn(false);
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        token,
        user,
        toggleNotification,
        login,
        logout,
        toggleNotificationHandler,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
